import { AppointmentResults } from "./elements/AppointmentResults";
import { StatusMessage } from "src/components/shared/status-message";
import styles from "./Appointments.module.scss";
import { useQuery } from "src/hooks/useQuery";

export function Appointments() {
  const query = useQuery();
  const success = query.get("success") ?? null;
  const deleteSuccess = query.get("delete_success") ?? null;
  const uploadFailure = query.get("upload_failure") ?? null;

  return (
    <div className={styles.root}>
      <header className={styles.header}>
        <h1 className="text-2xl leading-7 font-bold text-gray-900">
          Appointments
        </h1>
      </header>
      <div>
        {success && (
          <StatusMessage>Appointment created successfully!</StatusMessage>
        )}
        {deleteSuccess && (
          <StatusMessage>Appointment canceled successfully!</StatusMessage>
        )}
        {uploadFailure && (
          <>
            <StatusMessage>Appointment created successfully!</StatusMessage>
            <StatusMessage type="error">
              Authorization form upload failed. Please bring a physical copy of
              your authorization form to your appointment.
            </StatusMessage>
          </>
        )}
      </div>
      <div className={styles.contentWrapper}>
        <div>
          <AppointmentResults />
        </div>
      </div>
    </div>
  );
}
